import { LeadCaptureDataLayerEventProps } from './BlockBuilderProspectScheduler.types';

export function extractISODate(dateTimeString: string): string {
  const date = new Date(dateTimeString);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function removeLeadingZeroFromTime(str) {
  // This regex looks for a word boundary (\b),
  // followed by a zero and at least one digit (0\d+), then a colon.
  // It replaces that "0X:" with just "X:".
  // Formats slotDisplay repsonses from API to remove leading zero from time
  return str.replace(/\b0(\d+):/g, '$1:');
}

export function pushToDataLayer(eventData: LeadCaptureDataLayerEventProps) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
}
